/**
 * Integer codes for company.organizationType (US-centric legal entities).
 * Keep in sync with backend `modules/company/constants/organizationTypeEnums.js`.
 */
export const OrganizationType = Object.freeze({
  COMPANY: 0,
  SOLE_PROPRIETORSHIP_DBA: 1,
  GENERAL_PARTNERSHIP: 2,
  C_CORPORATION_INC: 3,
  S_CORPORATION: 4,
  NONPROFIT_CORPORATION: 5,
  LLC: 6,
  LIMITED_PARTNERSHIP: 7,
  LLP: 8,
  PROFESSIONAL_CORPORATION: 9,
  COOPERATIVE: 10,
  TRUST: 11,
  GOVERNMENT_OR_PUBLIC_ENTITY: 12,
  SERIES_LLC: 13,
  PLLC: 14,
  BENEFIT_CORPORATION: 15,
  CLOSE_CORPORATION: 16,
});

export const ORGANIZATION_TYPE_LABELS = Object.freeze({
  [OrganizationType.COMPANY]: 'Company',
  [OrganizationType.SOLE_PROPRIETORSHIP_DBA]: 'Sole Proprietorship (DBA)',
  [OrganizationType.GENERAL_PARTNERSHIP]: 'General Partnership (GP)',
  [OrganizationType.C_CORPORATION_INC]: 'C Corporation (Inc.)',
  [OrganizationType.S_CORPORATION]: 'S Corporation (S Corp)',
  [OrganizationType.NONPROFIT_CORPORATION]: 'Nonprofit Corporation',
  [OrganizationType.LLC]: 'LLC (Limited Liability Company)',
  [OrganizationType.LIMITED_PARTNERSHIP]: 'Limited Partnership (LP)',
  [OrganizationType.LLP]: 'LLP (Limited Liability Partnership)',
  [OrganizationType.PROFESSIONAL_CORPORATION]: 'Professional Corporation (PC / PA / PLLC)',
  [OrganizationType.COOPERATIVE]: 'Cooperative (Co-op)',
  [OrganizationType.TRUST]: 'Trust',
  [OrganizationType.GOVERNMENT_OR_PUBLIC_ENTITY]: 'Government or Public Entity',
  [OrganizationType.SERIES_LLC]: 'Series LLC',
  [OrganizationType.PLLC]: 'PLLC (Professional Limited Liability Company)',
  [OrganizationType.BENEFIT_CORPORATION]: 'Benefit Corporation (B Corp)',
  [OrganizationType.CLOSE_CORPORATION]: 'Close Corporation',
});

export const ORGANIZATION_TYPES_FOR_SELECT = Object.freeze(
  Object.entries(ORGANIZATION_TYPE_LABELS).map(([value, label]) => ({
    value: Number(value),
    label,
  }))
);

export function getOrganizationTypeLabel(value) {
  if (value === '' || value === null || value === undefined) {
    return 'Other';
  }
  const key = Number(value);
  if (!Number.isInteger(key) || key < 0) {
    return 'Other';
  }
  return ORGANIZATION_TYPE_LABELS[key] || 'Other';
}
